import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import SiteNavbar from '../SiteNavbar';
import SiteFooter from '../SiteFooter';
import './auth.css';

export default function ForgotPassword() {
  const [email, setEmail]     = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError]     = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/forgot-password', { email });
      setSuccess(data.message);
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao processar solicitação. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page-wrapper">
      <SiteNavbar />
      <div className="auth-page">
        <div className="auth-card narrow">
          <h1 className="auth-title">Esqueci minha senha</h1>
          <p className="auth-subtitle">
            Informe seu e-mail e enviaremos um link para você criar uma nova senha.
          </p>

          {error   && <div className="auth-error">{error}</div>}
          {success && <div className="auth-success">{success}</div>}

          {!success && (
            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label>E-mail</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  autoFocus
                  disabled={loading}
                  placeholder="seu@email.com"
                />
              </div>
              <button type="submit" className="auth-btn" disabled={loading || !email}>
                {loading ? 'Enviando...' : 'Enviar link de redefinição'}
              </button>
            </form>
          )}

          <div className="auth-footer" style={{ marginTop: 16 }}>
            <Link to="/login">← Voltar para o login</Link>
          </div>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}
